export default "__VITE_ASSET__1cec632f__"